export default {
    init() {
        // JavaScript to be fired on the cases page
    },
    finalize() {
        var carousel_interval = 5500;
        var carousel_interval_init;
        reset_carousel_interval();
        setTimeout(function() {
            $(".progress-wrapper .progress-bar").addClass("sliding");
        }, 500);

        $('.carousel').carousel({interval: 0});

        $(".carousel-indicators li").click(function () {
            switch_indicator(this);
            reset_carousel_interval();
        });

        $(".btn-less, .btn-more").click(function (e) {
            e.preventDefault();
            $(".carousel-indicators li[data-slide-to=" + $(this).data("slide-to") + "]").trigger("click");
        });

        $(".offer-button").click(function () {
            $(".offer-collapse").collapse('hide');
        });

        function switch_indicator(el) {
            $('.carousel').carousel($(el).data("slide-to"));
            $(".carousel-indicators li").removeClass('active');
            $(el).addClass('active');
        }

        function reset_carousel_interval() {
            clearInterval(carousel_interval_init);
            carousel_interval_init = setInterval(function() {
                $(".carousel").carousel("next");
                $('.carousel').carousel("pause");
                switch_indicator($(".carousel"));
            }, carousel_interval);
        }

        $('.carousel.main').on('slide.bs.carousel', function () {
            $(".progress-wrapper .progress-bar").removeClass("sliding");
        });

        $('.carousel.main').on('slid.bs.carousel', function (e) {
            $(".progress-wrapper .progress-bar").addClass("sliding");
            switch_indicator($(".carousel-indicators li[data-slide-to='" + e.to + "']"));
        });

        var url_parts = window.location.href.split("/");
        var elementHandler = $(url_parts[url_parts.length - 1]);
        if (elementHandler) {
            $(elementHandler).collapse('show');
            $(elementHandler).on('shown.bs.collapse', function () {
                var $collapse = $(elementHandler).closest('.offer-wrapper');
                setTimeout(function() {
                    $("html, body").animate({
                        scrollTop: $collapse.offset().top-25,
                    }, 1000);
                }, 500);
            });
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/joinus.js